import Scene = Phaser.Scene;
import {BasePanel} from "@/scenes.ui/base-panel";
import Container = Phaser.GameObjects.Container;
import SpriteUtils from "@/utils/sprite-utils";
import {Keys} from "@/constants/key";
import SoundUtils from "@/utils/sound-utils";

export class CompactBasePanel extends BasePanel {
    protected window!: Phaser.GameObjects.Image;
    protected xButton!: Phaser.GameObjects.Image;

    constructor(scene: Scene, canvas: HTMLCanvasElement, container: Container) {
        super(scene, canvas, 0, 327, container);
        this.window = SpriteUtils.addImage(this.scene, 0, 15, Keys.UI_ART_BASIC_WINDOW).setOrigin(0.5, 0.5).setInteractive();
        this.add(this.window);
        this.xButton = SpriteUtils.addImage(this.scene, 170, -300, Keys.ATLAS_PROFILE, Keys.UI_ART_X).setOrigin(0.5, 0.5).setInteractive();
        const clickSound = SoundUtils.addSound(scene, Keys.SOUND_SELECT);
        this.xButton.on('pointerup', () => {
            if (this.isOnTop()) {
                SoundUtils.play(clickSound);
                this.close();
            }
        });
        this.add(this.xButton);
    }
}
